let language = {
    DETAIL_RECOMMEND_TITLE: "你可能还喜欢",
    DETAIL_RECOMMEND_TIPS: "产品图片缺失",
}

export { language }